import React from 'react';
import axios from 'axios';
import {Modal, Button} from 'react-bootstrap';
import authHeader from "../services/AuthHeader";

const DeleteAdminModal = (props) => {
  const onChangeHandler = (e) => {
    props.onHide();
    axios
      .delete(
        process.env.REACT_APP_API_BASE + 'admin/' +
        props.user.adminId, { headers: authHeader() }
      )
      .then(props.setRerender(true))
  };
  const { setRerenderListings, ...modalProps } = props;
  return (
    <Modal
      {...modalProps}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          Delete This User
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table width="80%">
          <tbody>
          <tr>
            <td width="0%"><b>Star Id: </b></td>
            <td width="70%"><span className='delete-table'>{props.user.starId}</span></td>
          </tr>
          <tr>
            <td width="30%"><b>Last Name: </b></td>
            <td width="70%"><span className='delete-table'>{props.user.lastName}</span></td>
          </tr>
          <tr>
            <td width="30%"><b>First Name: </b></td>
            <td width="70%"><span className='delete-table'>{props.user.firstName}</span></td>
          </tr>
          <tr>
            <td width="30%"><b>Email: </b></td>
            <td width="70%"><span className='delete-table'>{props.user.email}</span></td>
          </tr>
          </tbody>
        </table>
        <div style={{marginTop:20}}>
        <Button
          className='btn btn-default'
          type='submit'
          onClick={onChangeHandler}
        >
          Delete
        </Button>
        </div>
      </Modal.Body>
      <Modal.Footer>

        <Button onClick={props.onHide}>Back</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteAdminModal;